import React from 'react';
import { useAuth } from './../auth/AuthContext';
import Chatbot from './../chatbot/chatbot'

function MobileComponent() {
  const { user, subscriptions } = useAuth();
  const isPremium = subscriptions?.chatbotPremium;
  const isStandard = subscriptions?.chatbotStandard;
  const isFreeMember = !isPremium && !isStandard;

  return (
    <div>

      {/* 共通コンテンツ */}
      <Chatbot />
    </div>
  )
}

export default MobileComponent;